import { useId, type ReactElement } from 'react';

/**
 * Teslyn single-ink mark (brand/logos/teslyn-mark-ink.svg: a disc with three survey lines and the aircraft cut
 * out), inlined with its geometry unchanged and the disc in currentColor, so it takes the colour of the text around
 * it (ink-muted in the "Powered by Teslyn" credit; brand/brand-book.md "White-label", brand/components/Logo).
 * Decorative next to the words, so it is hidden from screen readers. Each instance has its own mask id.
 */
export function TeslynMark({ size = 16 }: { readonly size?: number }): ReactElement {
  const mask = `teslyn-mark-${useId().replace(/[^A-Za-z0-9_-]/g, '')}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 2048 2048"
      aria-hidden="true"
      focusable="false"
      className="teslyn-mark"
    >
      <g transform="translate(-68.2667 -68.2667) scale(68.2667)">
        <defs>
          <mask id={mask}>
            <rect width="32" height="32" fill="#fff" />
            <g fill="none" stroke="#000" strokeWidth="2.1" strokeLinecap="round">
              <path d="M-3.21 23.9L13.34 10.97" />
              <path d="M0.24 28.31L17.58 14.77" />
              <path d="M3.69 32.73L20.24 19.8" />
            </g>
            <path
              transform="translate(21.83 11.44) rotate(52) scale(0.56)"
              fill="#000"
              d="M0 -8.4C1.25 -8.4 1.7 -7.2 1.7 -5.6L1.6 0.6L1.05 7.4L0.7 9.6L-0.7 9.6L-1.05 7.4L-1.6 0.6L-1.7 -5.6C-1.7 -7.2 -1.25 -8.4 0 -8.4ZM-1.4 -3.1L-11.3 -2.9Q-12 -2.88 -12 -2.2L-12 -1.1Q-12 -0.45 -11.3 -0.45L-1.4 0.5ZM1.4 -3.1L11.3 -2.9Q12 -2.88 12 -2.2L12 -1.1Q12 -0.45 11.3 -0.45L1.4 0.5ZM-0.9 7.3L-4.7 7.75Q-5.1 7.8 -5.1 8.2L-5.1 9.1Q-5.1 9.5 -4.7 9.5L4.7 9.5Q5.1 9.5 5.1 9.1L5.1 8.2Q5.1 7.8 4.7 7.75L0.9 7.3Z"
            />
          </mask>
        </defs>
        <g mask={`url(#${mask})`}>
          <circle cx="16" cy="16" r="15" fill="currentColor" />
        </g>
      </g>
    </svg>
  );
}
